import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Controparte } from 'src/app/common/models/controparte';
import { Parte } from 'src/app/common/models/parte';
import { CreazionePraticaStoreService } from '../../../services/creazione-pratica-store.service';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-step-parti-form-inserimento',
  templateUrl: './step-parti-form-inserimento.component.html',
  styleUrls: ['./step-parti-form-inserimento.component.css']
})
export class StepPartiFormInserimentoComponent implements OnInit {

  currentForm: string;
  form = FORM;
  @Input() parte: Parte;
  @Output() controparteChange: EventEmitter<Controparte> = new EventEmitter<Controparte>();
  componentDestroyed$: Subject<void> = new Subject<void>();
  controparti: Controparte[] = [];

  constructor(private creazionePraticaStoreService: CreazionePraticaStoreService){

    this.creazionePraticaStoreService.controparti$.pipe(takeUntil(this.componentDestroyed$)).subscribe(controparti => {
      this.controparti = [];
      if(controparti){
        this.controparti = controparti;
      }
    })
  }

  ngOnInit() {
    this.currentForm = (this.parte != null) ? FORM.ASSOCIATIVA : FORM.ANAGRAFICA;
  }

  onEmitAnagrafica(event: Parte){
    this.parte = event;
    this.currentForm = FORM.ASSOCIATIVA;
  }

  onEmitAssociativa(event: Controparte){
    this.controparteChange.emit(event);
    this.currentForm = FORM.ANAGRAFICA;
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

}

export enum FORM{
  ANAGRAFICA = 'anagrafica',
  ASSOCIATIVA = 'associativa'
}
